import { render, staticRenderFns } from "./MyHabitsEditModal.vue?vue&type=template&id=7c0828ce"
import script from "./MyHabitsEditModal.vue?vue&type=script&lang=js"
export * from "./MyHabitsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports